import * as yup from "yup";

interface RC4ValidationSchemaProps {
  languageSpecialization: boolean;
}

const RC4WebValidationSchema = ({
  languageSpecialization,
}: RC4ValidationSchemaProps) => {
  let schema = yup.object().shape({
    website: yup
      .string()
      .url("Invalid Website (url must include https:// )")
      .max(500, "Website cannot exceed 500 characters")
      .required("Website is required"),
    description: yup.string().required("Description is required"),
    description2ndLanguage: yup.string(),
  });

  const secondLanguageFields = {
    description2ndLanguage: yup
      .string()
      .required("Description in second language is required"),
  };

  if (languageSpecialization) {
    schema = schema.shape(secondLanguageFields);
  }

  return schema;
};

export default RC4WebValidationSchema;
